import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

// Sélecteur du pays de facturation (résidence) — enregistré dans settings.billing_country
export function BillingCountrySelect({ value, countries, source, compact = false, testId = "billing-country-select" }) {
  const { t } = useLang();
  const { refresh } = useAuth();
  const qc = useQueryClient();
  const change = async (cc) => {
    if (!cc) return;
    try {
      await api.put("/settings", { billing_country: cc });
      await Promise.all([refresh(), qc.invalidateQueries({ queryKey: ["plans"] }), qc.invalidateQueries({ queryKey: ["payments-me"] })]);
      toast.success(t("billing_country_saved"));
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  return (
    <div className={compact ? "flex items-center gap-2" : "flex flex-wrap items-center gap-2"}>
      <select value={value || ""} onChange={(e) => change(e.target.value)} aria-label={t("billing_country")} data-testid={testId}
        className="h-9 rounded-full border border-border bg-card px-3 text-sm">
        {!value && <option value="">{t("billing_select_country")}</option>}
        {countries.map((cc) => <option key={cc} value={cc}>{t(`cn_${cc}`)}</option>)}
      </select>
      {value && source === "store_zone" && <span className="text-[11px] text-muted-foreground" data-testid="billing-country-source">({t("billing_from_stores")})</span>}
    </div>
  );
}
